import React from "react";
import IframeForm from "./IframeForm";

export default function VideoForm({ IframeVideo ,SectionTitle}) {

  return (
    <>
      
      <section className="videoForm_section py-5">
    <div className="container">

        <div className="videoForm-header text-center mb-5">

            <span className="videoForm-badge">
                India Name Change Gazette Service
            </span>

            <h2 className="videoForm-title">
                {SectionTitle}
            </h2>

            <div className="videoForm-divider"></div>

        </div>

        <div className="row g-4 align-items-stretch">

            {/* Video Section */}
            <div className="col-lg-8">

                <div className="video-card">

                    <div className="video-top-content">
                        <h3>Watch Complete Process Video</h3>
                        <p>
                            Learn the complete Gazette process step by step before applying.
                        </p>
                    </div>

                    <div className="video-wrapper">
                        <iframe
                            src={`https://www.youtube.com/embed/${IframeVideo}`}
                            title="Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>

                </div>

            </div>

            {/* Form Section */}
            <div className="col-lg-4">

        <IframeForm/>

            </div>

        </div>

    </div>
</section>

{/* End Video Area */}





    </>
  );
}
